<template>
  <div class="container d-flex flex-column align-items-center justify-content-center">
    <div class="col-md-10 col-lg-9 col-xl-8 m-5 mx-auto">
      <div class="card mb-3 rounded-4 overflow-hidden">
        <div class="row g-0">
          <div class="col-sm-5 d-flex align-items-end position-relative overflow-hidden">
            <div class="bg-gradient-circle position-absolute z-0 w-75 h-100"></div>
            <img :src="(['testing'].includes($store.getters.selectedTest.raw_status)) ? doctor : worriedDoctor" class="img-fluid mt-5 mx-auto z-1" alt="Health">
          </div>

          <div v-if="$store.getters.selectedTest.raw_status === 'transfer_qc_failed'" class="col-sm-7">
            <div class="card-body d-flex flex-column align-items-start justify-content-center h-100 p-4">
              <h5 class="card-title text-start my-3">Action required</h5>
              <p class="card-text text-start">
                <small class="text-muted">We have encountered an issue with processing your DNA, please reupload.</small>
              </p>
              <p class="card-text text-start mmt-4">
                <small class="text-muted">{{ $store.getters.selectedTest.errorMessage }}</small>
              </p>
              <router-link :to="{ name: 'reupload-dna', params: { barcode: $store.getters.profile.profile.barcode }}">
                <button class="btn btn-primary">Reupload your DNA</button>
              </router-link>
            </div>
          </div>
          
          <div v-else-if="$store.getters.selectedTest.raw_status === 'testing_failed'" class="col-sm-7">
            <div class="card-body d-flex flex-column align-items-start justify-content-center h-100 p-4">
              <h5 class="card-title text-start my-3">Testing failed</h5>
              <p class="card-text text-start">
                <small class="text-muted">Your file was successfully uploaded be we were unable to test it. This is usually down to an issue with the sample, for example low sample quality.</small>
              </p>
              <p class="card-text text-start">
                <small class="text-muted">
                  For more information feel free to reach to our support team at
                  <a href="mailto:help@livingdna.com" class="text-cobalt-500 font-semibold"
                    >help@livingdna.com</a
                  >.
                </small>
              </p>
            </div>
          </div>

          <div v-else-if="$store.getters.selectedTest.raw_status === 'testing'" class="col-sm-7">
            <div class="card-body d-flex flex-column align-items-start justify-content-center h-100 p-4">
              <h5 class="card-title text-start my-3">Preparing results</h5>
              <p class="card-text text-start">
                <small class="text-muted">
                  Did you know? 41% of our American customers have Scandinavian ancestry
                </small>
              </p>
            </div>
          </div>

          <div v-else class="col-sm-7">
            <div class="card-body d-flex flex-column align-items-start justify-content-center h-100 p-4">
              <h5 class="card-title text-start my-3">Failed to load data</h5>
              <p class="card-text text-start">
                <small class="text-muted">We have failed to load your DNA result. Please contact support at
                  <a class="text-cobalt-500 font-semibold" href="mailto:help@livingdna.com">help@livingdna.com</a> for further assistance.
                </small>
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.bg-gradient-circle {
  background: url('@/assets/gradient-circle.png') no-repeat;
  background-position: right;
  // background-size: cover;
}

img {
  max-height: 330px;
}
</style>

<script setup>
import doctor from "@/assets/characters/blood-test-inspiration-new.png";
import worriedDoctor from "@/assets/characters/upgrade-required-image.png";
</script> 